<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    class="sale-form"
  >
    <v-container>
      <h2 class="title">Select Customer and Battery</h2>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            v-model="sale.customerId"
            :loading="loadingCustomers"
            :items="customers"
            :search-input.sync="textFilterCustomers"
            :cache-items=false
            flat
            label="Select From Existing Customers *"
            outlined
            item-text="fullname"
            item-value="id"
            :rules="[rules.required]"
            required
            @change="customerChanged"
            :no-filter="false"
            :filter="filterCustomer"
          >
            <template v-slot:no-data>
              <v-btn to="/customers/add" sm text color="success" width="100%">
                <v-icon sm>add</v-icon> Add Customer
              </v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="sale.customer"
        >
          <v-autocomplete
            v-model="sale.customer.carId"
            :loading="loadingCars"
            :items="cars"
            :search-input.sync="textFilterCars"
            :cache-items=false
            flat
            label="Select Car *"
            outlined
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
            required
            @change="changeCar"
          >
            <template v-slot:no-data>
              <v-btn :to="`/customers/edit/${sale.customerId}`" sm text color="success" width="100%">
                <v-icon sm>add</v-icon> Add Car
              </v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="sale.customer"
        >
          <v-autocomplete
            v-model="sale.customer.addressId"
            :loading="loadingAddresses"
            :items="addresses"
            :search-input.sync="textFilterAddress"
            :cache-items=false
            flat
            label="Select Address *"
            outlined
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
            required
            @change="changeAddress"
          >
            <template v-slot:no-data>
              <v-btn :to="`/customers/edit/${sale.customerId}`" sm text color="success" width="100%">
                <v-icon sm>add</v-icon> Add Address
              </v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            v-model="sale.batteryId"
            :loading="loadingBatteries"
            :items="batteries"
            :search-input.sync="textFilterBattery"
            :cache-items=false
            flat
            label="Select Battery *"
            outlined
            item-text="id"
            item-value="id"
          >
            <template v-slot:no-data>
              <v-btn to="/customers/add" sm text color="success" width="100%">
                <v-icon sm>add</v-icon> Add Customer
              </v-btn>
            </template>
          </v-autocomplete>
        </v-col>

      </v-row>
      <div v-if="sale.customer">
        <table cellspacing="10px">
          <tr>
            <td>
              <p class="mb-0"><strong>Name</strong> - {{sale.customer.fullname}}</p>
              <p class="mb-0"><strong>Email</strong> - {{sale.customer.email}}</p>
              <p class="mb-0"><strong>Phone</strong> - {{sale.customer.phone}}</p>
            </td>
            <td>
              <p class="mb-0"><strong>Make/Model</strong> - {{sale.customer.make}} / {{sale.customer.model}}</p>
              <p class="mb-0"><strong>Year</strong> - {{sale.customer.year}}</p>
              <p class="mb-0"><strong>Vin</strong> - {{sale.customer.vin}}</p>
            </td>
            <td>
              <p class="mb-0"><strong>Street</strong> - {{sale.customer.street}}</p>
              <p class="mb-0"><strong>City</strong> - {{sale.customer.city}}</p>
              <p class="mb-0"><strong>Zipcode</strong> - {{sale.customer.zipcode}}</p>
            </td>
          </tr>
        </table>
        

      </div>
      <ReceiptDetails
        :form="sale"
        :itemOptions="itemOptions"
        :warrantyOptions="warrantyOptions"
      />
      <PaymentDetails
        :form="sale"
        :options="paymentOptions"
      />
      <v-btn
        color="success"
        class="mr-4"
        @click="submit"
      >
        Save
      </v-btn>
      <v-btn
        color="success"
        class="mr-4"
        @click="saveAndNew"
        v-if="!$route.params.id"
      >
        Save And New
      </v-btn>
      <v-btn
        color="error"
        class="mr-4"
        @click="reset"
      >
        Reset
      </v-btn>
    </v-container>

  </v-form>
</template>

<script>
import api from "@/api";
import { cloneDeep } from "lodash";
import dotty from "dotty";
import ReceiptDetails from "./ReceiptDetails.vue";
import PaymentDetails from "./PaymentDetails.vue";

const defaultItem = { type: '', description: '', value: '' };
export default {
  name: "AddCell",
  components: {
    ReceiptDetails,
    PaymentDetails
  },
  data: (vm) => ({
    valid: false,
    loadingCustomers: false,
    loadingCars: false,
    loadingAddresses: false,
    customers: [],
    textFilterCustomers: null,
    selectedCustomer: null,
    cars: [],
    addresses: [],
    textFilterCars: null,
    textFilterAddress: null,
    loadingBatteries: false,
    selectedBattery: null,
    batteries: [],
    textFilterBattery: null,
    sale: {
      customerId: '',
      batteryId: '',
      date: new Date().toISOString().substr(0, 10),
      miles: {
        description: '',
        value: ''
      },
      warranty: {
        description: '',
        value: ''
      },
      notes: '',
			items: [
				{...defaultItem}
			],
			payments: [
				{...defaultItem}
			],
    },
    rules: {
      required: v => !!v || 'required',
      email: v => /.+@.+/.test(v) || 'E-mail must be valid',
      max: (len) => v => v.length <= len || `Must be less than ${len} characters`,
    },
    warrantyOptions: [
      // { value: "45D", text: "45 Days"},
      // { value: "6M", text: "6 Months"},
      // { value: "12M", text: "12 Months"},
      // { value: "12MNB", text: "12 Months New Battery"},
      // { value: "24M", text: "24 Months"},
      // { value: "36MNC", text: "36 Months New Cells"},
      // { value: "36MNB", text: "36 Months New Battery"}
      { value: "45D", text: "Bronze Battery (45D)"},
      { value: "6M", text: "Silver Battery (6M)"},
      { value: "12M", text: "Gold Battery (12M)"},
      { value: "24M", text: "Platinum Battery (24M)"},
      { value: "36M", text: "Diamond Battery (36M)"},
      { value: "48M", text: "Emerald Battery (48M)"},
      { value: "60M", text: "Jadeite Battery (60M)"},
    ],
    itemOptions: [
      { value:"part", text: "Part" },
      { value:"installation", text: "Installation" },
      { value:"tax", text: "Tax" },
      { value:"labour", text: "Labour" },
      { value:"standardfee", text: "Standard Fee (in $)" },
      { value:"travelfee", text: "Travel Fee (in $)" },
      { value:"otherfee", text: "Other Fee (in $)" },
      { value:"corecharge", text: "Core Charge (in $)" },
      { value:"ccfee", text: "CC Fee (in $)" },
    ],
    paymentOptions: [
      { value: "cc", text: "Credit Card" },
      { value: "cash", text: "Cash" },
      { value: "check", text: "Check" },
      { value: "zelle", text: "Zelle" },
    ],
    existingSale: {}
  }),
  watch: {
    textFilterCustomers(val) {
      if(this.selectedCustomer && this.selectedCustomer.fullname === val) return;
      this.searchCustomers(val)
    },
    textFilterBattery(val) {
      if(this.sale.batteryId && this.sale.batteryId === val) return;
      this.searchBattery(val)
    },
    sale:{
      handler() {
        if(this.sale.customerId) this.customerDetail(this.sale.customerId);
      },
      deep: true
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if(this.$route.params.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    getData() {
      let total = 0;
      this.sale.items.forEach((item) => {
        if(item.value) total += parseFloat(item.value);
      });
      if (!this.sale.miles.value) alert('miles missing');
      if (!this.sale.warranty.value) alert('warranty missing');
      if (!this.sale.miles.value || !this.sale.warranty.value) return;
      const data = cloneDeep(this.sale);

      if (this.sale.customer.id) data.customerId = this.sale.customer.id;
      if (this.sale.customer.carId) data.carId = this.sale.customer.carId;
      if (this.sale.customer.addressId) data.addressId = this.sale.customer.addressId;
      data.total = parseFloat(total.toFixed(2));
      return data;
    },
    async save () {
      if (this.$refs.form.validate()) {
        try {
          const data = this.getData();
          await api.addSale(data)
          this.$toast.success("Sale Added Successfully");
          // this.reset();
          this.$router.push("/sales")
        } catch (error) {
          this.$toast.error("Error Adding Sale");
        }
      }
    },
    async saveAndNew() {
      if (this.$refs.form.validate()) {
        try {
          const data = this.getData();
          await api.addSale(data)
          this.$toast.success("Sale Added Successfully");
          this.reset();
        } catch (error) {
          this.$toast.error("Error Adding Sale");
        }
      }
    },
    async update() {
      try {
        const data = this.getData();
        await api.updateSale(this.$route.params.id, data);
        this.$toast.success("Sale Updated Successfully");
        this.$router.push("/sales")
      } catch (error) {
        this.$toast.error("Error Updating Sale");
      }
    },
    reset () {
      this.$refs.form.reset();
    },
    async searchBattery(val) {
      try {
        this.loadingBatteries = true;
        const { data } = await api.getAvailableBatteriesList(val, 5, 1);
        // this.batteries = 
        let selectedExists = false
        const selectedBattery = this.existingSale.selectedBattery;
        const searchResult = data.data.map(battery => {
          const batteryId = battery.id.toString();
          if (selectedBattery?.id && selectedBattery.id === batteryId) {
            selectedExists = true
          }
          return {
            ...battery,
            id: batteryId
          }
        });
        if (!selectedExists && selectedBattery) {
          searchResult.unshift(selectedBattery)
        }
        this.batteries = searchResult;
      } catch (error) {
        // console.log(error)
        this.$toast.error("Error Finding Battery");
      }
      this.loadingBatteries = false;
    },
    async searchCustomers(val) {
      try {
        this.loadingCustomers = true;
        const { data } = await api.searchCustomers(val, 5, 1);
        this.customers = data.data;
      } catch (error) {
        this.$toast.error("Error Finding Customer");
      }
      this.loadingCustomers = false;
    },
    async updateCars(customerId){
      try {
        this.loadingCars = true;
        const { data } = await api.getCustomerCars(customerId);
        this.cars = data.map(car => {
          car.name = `${car.make} ${car.model} (${car.year}) - ${car.vin}`
          return car;
        });
        this.loadingCars = false;
      } catch (error) {
        this.$toast.error("Error Finding Car");
      }
    },
    async updateAddress(customerId){
      try {
        this.loadingAddresses = true;
        const { data } = await api.getCustomerAddresses(customerId);
        this.addresses = data.map(addr => {
          addr.name = `${addr.street} ${addr.city}`
          return addr;
        });
        this.loadingAddresses = false;
      } catch (error) {
        this.$toast.error("Error Finding Car");
      }
    },
    customerDetail (id) {
      const customerId = dotty.get(this.sale, 'customer.id');
      if(customerId === id) return;
      const customer = this.$clone(this.customers.find((v) => v.id == id));
      this.sale.customer = customer;
      this.updateCars(id);
      this.updateAddress(id);
    },
    customerChanged(id){
      const customer = this.$clone(this.customers.find((v) => v.id == id));
      this.selectedCustomer = customer;
    },
    batteryChanged(id){
      const battery = this.$clone(this.batteries.find((v) => v.id == id));
      this.selectedBattery = battery;
    },
    changeCar(id){
      const car = this.$clone(this.cars.find((v) => v.id == id));
      this.sale.customer.make = car.make
      this.sale.customer.model = car.model
      this.sale.customer.vin = car.vin
      this.sale.customer.year = car.year
    },
    changeAddress(id){
      const address = this.$clone(this.addresses.find((v) => v.id == id));
      this.sale.customer.street = address.street;
      this.sale.customer.city = address.city;
      this.sale.customer.zipcode = address.zipcode;
    },
    async getSale(id) {
      try {
        const { data } = await api.getSale(id);
        this.customers = [data.customer];
        this.batteries = [{...data.battery, id: data.batteryId.toString()}];
        this.sale = {
          ...data,
          batteryId: data.batteryId.toString()
        };
        this.existingSale = cloneDeep({
          ...data,
          selectedBattery : {
            ...data.battery,
            id: data.batteryId.toString()
          }
        })
        this.updateCars(data.customerId);
        this.updateAddress(data.customerId);
      } catch (error) {
        this.$toast.error("Error Found Sale");
        this.$router.push("/sales");
      }
    },
    filterCustomer() {
      return true;
    }
  },
  mounted() {
    if(this.$route.params && this.$route.params.id) {
      this.getSale(this.$route.params.id);
    } else {
      this.searchCustomers();
      this.searchBattery();
    }
  }
};
</script>